/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientDetailsViewModel } from './ClientDetailsViewModel';
import {
    ClientDetailsViewModelFromJSON,
    ClientDetailsViewModelFromJSONTyped,
    ClientDetailsViewModelToJSON,
} from './ClientDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfClientDetailsViewModel
 */
export interface ResultOfClientDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfClientDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfClientDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfClientDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ClientDetailsViewModel}
     * @memberof ResultOfClientDetailsViewModel
     */
    data?: ClientDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfClientDetailsViewModel interface.
 */
export function instanceOfResultOfClientDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfClientDetailsViewModelFromJSON(json: any): ResultOfClientDetailsViewModel {
    return ResultOfClientDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfClientDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfClientDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ClientDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfClientDetailsViewModelToJSON(value?: ResultOfClientDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ClientDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

